const __WEBPACK_NAMESPACE_OBJECT__ = netset.etailer.desktop.recaptcha;